export default {
  props: {
    // the options of BetterScroll
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}


// WEBPACK FOOTER //
// ./packages/image-preview/src/common/scroll.js